$(window).scroll(function() {
    if ($(window).scrollTop() > $(".header").innerHeight()) {
        $(".scroll-top").show(300);
    } else {
        $(".scroll-top").hide(300);
    }
});
